import { z } from 'zod';
import { paginationQueryFor } from '../common/pagination.js';
export const categoryStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createCategorySchema = z.object({
    nameAr: z.string().trim().min(1).max(120),
    nameEn: z.string().trim().min(1).max(120),
    description: z.string().trim().max(500).optional(),
});
export const updateCategorySchema = createCategorySchema.partial();
export const changeCategoryStatusSchema = z.object({ status: categoryStatusSchema });
export const categoryListQuerySchema = paginationQueryFor([
    'id',
    'nameAr',
    'nameEn',
    'status',
    'createdAt',
    'updatedAt',
]).extend({
    status: categoryStatusSchema.optional(),
});
//# sourceMappingURL=contract.js.map